import FormattedMessage from 'I18n/components/FormattedMessage';
import { BulkActions, Edit } from 'customer-data-bulk-actions';
import { SELECTION_METHOD_BY_IDS, SELECTION_METHOD_BY_QUERY } from 'customer-data-bulk-actions/constants/selectionMethods';
import { BulkActionsContextProvider } from 'customer-data-bulk-actions/contexts/bulkActionsContext';
import { MARKETING_EMAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import useCrmSearchQuery from 'framework-listing-lib/hooks/useCrmSearchQuery';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import useHasAllScopes from 'messaging-management-lib/user/hooks/useHasAllScopes';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BulkEdit({
  selectedIds,
  areAllEmailsSelected,
  clearSelection
}) {
  const {
    filterGroups,
    sorts,
    query,
    objectTypeId
  } = useCrmSearchQuery();
  const hasAllGates = useHasAllGates();
  const hasAllScopes = useHasAllScopes();
  const onEditSuccess = useCallback(({
    propertyValues
  }) => {
    clearSelection();
    listingLibObserver.updatePropertyValues({
      propertyValues,
      selectedIds
    });
  }, [clearSelection, selectedIds]);
  const onEditFailure = useCallback(() => {
    FloatingAlertStore.addAlert({
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.bulkActions.edit.editError"
      }),
      type: 'danger'
    });
  }, []);
  return /*#__PURE__*/_jsx(BulkActionsContextProvider, {
    objectTypeId: MARKETING_EMAIL_TYPE_ID,
    children: /*#__PURE__*/_jsx(BulkActions, {
      selectionObjectTypeId: MARKETING_EMAIL_TYPE_ID,
      selectionMethod: areAllEmailsSelected ? SELECTION_METHOD_BY_QUERY : SELECTION_METHOD_BY_IDS,
      selectionIds: selectedIds.map(String),
      selectionCrmSearchQuery: {
        filterGroups,
        sorts: sorts,
        query,
        objectTypeId,
        requestAction: 'EDIT'
      },
      children: /*#__PURE__*/_jsx(Edit, {
        modalProps: {
          hasAllGates,
          hasAllScopes,
          onFailure: onEditFailure,
          onSuccess: onEditSuccess,
          filterProperty: property => !property.hubspotDefined
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.table.bulkActions.edit.buttonText"
        })
      })
    })
  });
}